import React from 'react'
import { FooterProps } from '../footerWrapper'
import { BannerJobsOpenings } from '../BannerJobsOpenings/BannerJobsOpenings'
import * as Accordion from '@radix-ui/react-accordion'
import {
  AccordionContent,
  AccordionTrigger,
} from '@/components/Accordion/Accordion'
import getSections from '../../helpers/getSections'
import * as styles from './MobileFooterWrapper.css'
import BuyFromApp from '../BuyFromApp/BuyFromApp'

function MobileFooterWrapper({
  lang = 'pt',
  variant = 'default',
  onClickOption,
  showBannerJobsOpenings = false,
  onClickBannerJobs,
}: FooterProps) {
  return (
    <div className={styles.Container}>
      <BuyFromApp lang={lang} />
      {showBannerJobsOpenings && (
        <div className={styles.ContainerBannerJobsOpenings}>
          <BannerJobsOpenings lang={lang} onClick={onClickBannerJobs} />
        </div>
      )}
      <Accordion.Root collapsible type="single">
        {getSections(lang).map((section) => (
          <Accordion.Item
            value={section.title}
            key={section.key}
            className={styles.AccordionItem}
          >
            <AccordionTrigger
              variant={variant}
              type="mobile"
              positionIcon="end"
            >
              {section.title}
            </AccordionTrigger>
            <AccordionContent>
              <ul className={styles.AccordionContentUl}>
                {section.options.map((option, idx) => (
                  <li
                    key={`section-option-${idx}`}
                    className={styles.AccordionContentLi}
                  >
                    <a
                      className={styles.AccordionLink}
                      target="_blank"
                      href={option.link}
                      rel="noopener noreferrer"
                      onClick={() =>
                        onClickOption?.({
                          category: section.title,
                          label: option.name,
                        })
                      }
                    >
                      {option.name}
                    </a>
                  </li>
                ))}
              </ul>
            </AccordionContent>
          </Accordion.Item>
        ))}
      </Accordion.Root>
    </div>
  )
}

export default MobileFooterWrapper
